import { Button } from '@mui/material'
import React from 'react'
import useScrollToFirstError from './useScrollToFirstError'

const SubmitButton = ({ isSubmitting, disabled = false }: { isSubmitting: boolean; disabled?: boolean }) => {
  const ref = useScrollToFirstError<HTMLButtonElement>()
  return (
    <Button
      ref={ref}
      color="primary"
      disabled={isSubmitting || disabled}
      type="submit"
      variant="contained"
      style={{ marginTop: '16px' }}
    >
      Add
    </Button>
  )
}

export default SubmitButton
